import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CheckoutProvider } from "@/components/CheckoutContext";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import InfiniteRenderMarquee from "@/components/InfiniteRenderMarquee";
import SocialProofBar from "@/components/SocialProofBar";
import VaultPreview from "@/components/VaultPreview";
import ValueComparison from "@/components/ValueComparison";
import Testimonials from "@/components/Testimonials";
import PricingSection from "@/components/PricingSection";
import StepByStepGuide from "@/components/StepByStepGuide";
import Footer from "@/components/Footer";
import FloatingCTA from "@/components/FloatingCTA";
import UpiCheckoutModal from "@/components/UpiCheckoutModal";
import SupportWidget from "@/components/SupportWidget";
import RefundPolicy from "@/pages/RefundPolicy";
import TermsOfService from "@/pages/TermsOfService";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

function LandingPage() {
  return (
    <>
      <Navbar />
      <HeroSection />
      <InfiniteRenderMarquee />
      <SocialProofBar />
      <VaultPreview />
      <ValueComparison />
      <Testimonials />
      <PricingSection />
      <StepByStepGuide />
      <Footer />
      <FloatingCTA />
      <SupportWidget />
      <UpiCheckoutModal />
    </>
  );
}

function App() {
  return (
    <div className="App" data-testid="app-root">
      <CheckoutProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </BrowserRouter>
      </CheckoutProvider>
    </div>
  );
}

export default App;
